import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_URL } from './api-url.token';

export const apiUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = inject(API_URL);

  if (req.url.startsWith('/')) {
    req = req.clone({ url: `${apiUrl}${req.url}` });
  }

  return next(req);
};
